import { createContext, useState } from 'react';

const GlobalContext = createContext({
    isShowModal: false,
    modalInfo: null,
    showModal: (modalInfo) => { },
    hideModal: () => { },
    setLayoutModel: (model) => { },
    layoutModel: null,
    setOrderInEdit: (order) => { },
    orderInEdit: '',
    setOrderPropertyInEdit: (currentPropId, properties) => { },
    orderPropertyInEdit: '',
    setOrderStatus: (s) => { },
    orderStatus: '',
    hasCurrentSeasonSubmittedOrder:'',
    setHasCurrentSeasonSubmittedOrder:()=>{}
});

export function GlobalContextProvider(props) {
    const [isShowModal, setIsShowModal] = useState(false);
    const [modalInfo, setModalInfo] = useState({});
    const [layoutModel, setLayoutModel] = useState(null);
    const [orderInEdit, setOrderInEdit] = useState(null);
    const [orderPropertyInEdit, setOrderPropertyInEdit] = useState(null);
    const [orderStatus, setOrderStatus] = useState(null);
    const [hasCurrentSeasonSubmittedOrder, setHasCurrentSeasonSubmittedOrder] = useState(false);

    function showModalHandler(modalInfo) {
        setModalInfo(modalInfo);
        setIsShowModal(true);
    }

    function hideModalHandler() {
        setIsShowModal(false);
    }

    function setLayoutModelHandler(model) {
        setLayoutModel(model);
    }

    function setOrderInEditHandler(order) {
        setOrderInEdit(!!order ? {
            name: order.name,
            status: order.status,
            isShippingVerified: order.isShippingVerified
        } : null);
    }

    function setOrderPropertyInEditHandler(currentPropId, properties) {
        let index = properties.findIndex(x => x.id === currentPropId);
        let newIndex = index + 1;
        newIndex = newIndex <= properties.length - 1 ? newIndex : 0;
        let nextProperty = properties[newIndex];
        if (!nextProperty.readOnly) {
            setOrderPropertyInEdit(nextProperty.id);
        } else {
            setOrderPropertyInEditHandler(nextProperty.id, properties);
        }
    }

    const context = {
        isShowModal: isShowModal,
        modalInfo: modalInfo,
        showModal: showModalHandler,
        hideModal: hideModalHandler,
        setLayoutModel: setLayoutModelHandler,
        layoutModel: layoutModel,
        setOrderInEdit: setOrderInEditHandler,
        orderInEdit: orderInEdit,
        setOrderPropertyInEdit: setOrderPropertyInEditHandler,
        orderPropertyInEdit: orderPropertyInEdit,
        setOrderStatus: setOrderStatus,
        orderStatus: orderStatus,
        setHasCurrentSeasonSubmittedOrder:setHasCurrentSeasonSubmittedOrder,
        hasCurrentSeasonSubmittedOrder:hasCurrentSeasonSubmittedOrder
    };

    return (
        <GlobalContext.Provider value={context}>
            {props.children}
        </GlobalContext.Provider>
    );
}

export default GlobalContext;